import { render, staticRenderFns } from "./create_v1.vue?vue&type=template&id=1359539c"
import script from "./create_v1.vue?vue&type=script&lang=js"
export * from "./create_v1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports